import { useQuery, useQueryClient } from '@tanstack/react-query';
import React, { useCallback, useState } from 'react';
import { ApiClient } from '../../api/ApiClient';
import { v2 } from '../../api/ApiInterfaceV2';
import { useAppEvent, useObserver } from '../../CodesThatsGottaGoSomewhereElse';
import { Icon } from '../../concepts/resources/Icon';
import { Colors } from '../../ui';
import { Badge } from '../../ui/Badge';
import { HeaderButton } from '../../ui/HeaderButton';
import { Position } from '../../ui/Position';
import { Tip } from '../../ui/Tip';
import { useDashboardVersion } from '../account/AccountHooks';
import { Popover } from '../canvas/ui/Popover';
import { useResolve } from '../Container';
import { Flexer } from '../dashboard/elements/LayoutElements';
import { PreferencesModel } from '../preferences/PreferencesModel';
import { ProfileModel } from '../ProfileModel';
import { NotificationsView } from './NotificationsView';

const UnreadCount = ({ size }: { size?: 'sm' | 'md' }) => {
    const api = useResolve(ApiClient);

    const { data } = useQuery({
        queryKey: ['notifications.count'],
        queryFn: async () => await api.exec(v2.notifications.count({ status: 'unread' })),
    });

    if (!data?.count) return null;

    return <Badge round color={Colors.negative} size={size}>{Math.min(data.count, 99)}</Badge>;
};

export const NotificationsButton = () => {

    const { notificationUnreads } = useObserver(useResolve(PreferencesModel));

    const [open, setOpen] = useState(false);
    const onToggle = useCallback(() => setOpen(!open), [open, setOpen]);

    const me = useResolve(ProfileModel);
    const qc = useQueryClient();

    useAppEvent('user:notification', (pushData) => {
        if (pushData.userId === me.id) {
            qc.invalidateQueries(['notifications.count']);
        }
    });


    const version = useDashboardVersion();
    if (version !== 'next') return null;

    return <Popover
        placement="bottom-end"
        content={<NotificationsView />}
        inner={{ direction: 'down' }}
        open={open}
        onOpenChange={setOpen}
    >
        <Tip text="Notifications" position="bottom" disabled={open}>
            <Flexer relative>
                <HeaderButton data-action="header.openNotifications" active={open} onClick={onToggle}>
                    <Icon size="1.5" src="deqo://icons/dash/notifications" />
                </HeaderButton>
                {notificationUnreads &&
                    <Position at="topRight" inset="-0.25">
                        <UnreadCount size="sm" />
                    </Position>
                }
            </Flexer>
        </Tip>
    </Popover>;
};
